<template>
  <div class="pa-2">
    <div v-if="!itemSlug" class="d-flex flex-row justify-space-between">
      <div class="text-h5">Articles Admin</div>
      <div>
        <v-btn depressed text :to="{ path: '/boss/articles/new' }"
          ><v-icon color="green" class="mr-1">mdi-plus</v-icon> Add
          Article</v-btn
        >
      </div>
    </div>
    <v-fade-transition>
      <generic-admin-list
        v-if="!itemSlug"
        idField="slug"
        title="Articles"
        itemsKey="articles"
        :headers="headers"
        api="articleList"
        editPath="/boss/articles"
        detailPath="/articles/"
        :refresh="refresh"
        @loaded="refresh = false"
        class="my-2"
        sortBy="updated"
        :sortDesc="true"
      ></generic-admin-list>
      <!-- detailPath="/ocular-conditions/details/" -->

      <edit-article
        v-else
        :slug="itemSlug"
        :adminData="adminData"
        class="my-2"
        @cancel="itemSlug = null"
      >
      </edit-article>
    </v-fade-transition>
  </div>
</template>

<script>
// import Name from "../dir/file";
import ApiServices from "@/services/ApiServices";
import GenericAdminList from "@/components/adminStuff/GenericAdminList";
import UserMixin from "@/assets/js/UserMixin";
// import axios from "axios";
import EditArticle from "./EditArticle";

export default {
  name: "ArticlesAdminHome",
  components: {
    GenericAdminList,
    EditArticle,
  },
  mixins: [UserMixin],
  props: {},
  data: function () {
    return {
      refresh: true,
      // editId: null,
      // updatedSnackbar: false,
      itemSlug: null,
      adminData: null,
      headers: [
        { value: "id", text: "Id" },
        { value: "name", text: "Title" },
        { value: "section_name", text: "Section" },
        { value: "category_name", text: "Category" },
        { value: "description", text: "Description" },
        { value: "display", text: "Published" },
        { value: "added", text: "Added" },
        { value: "updated", text: "Updated" },
      ],
    };
  },
  methods: {
    getAdminData() {
      let authPS = this.auth_paramstring; // (from UserMixin)
      ApiServices.adminData("articles", authPS)
        .then((response) => {
          this.adminData = response.data;
        })
        .catch((error) => {
          console.log("error", error);
        })
        .finally(() => {});
    },
  },
  computed: {},
  mounted() {
    this.itemSlug = this.$route?.params?.item ? this.$route.params.item : null;
    this.getAdminData();
  },
};
</script>

<style scoped></style>
